import React, { useState, useEffect } from "react";
import { Box } from "Components/Base/Layout/Box";
import { useLearningCatalogue } from "../context";
import { SORT_ORDER_NEXT_APPLICATION_INT } from "../constants";
import CourseListItem from "./CourseList/CourseListItem";

const CourseList = ({ languageContext }) => {
  const { state } = useLearningCatalogue();
  const { learningActivities, sortOrder } = state;

  const isNextApplicationSort =
    Number(sortOrder) === SORT_ORDER_NEXT_APPLICATION_INT;
  const nextApplicationSortReferenceAt =
    learningActivities?.nextApplicationSortReferenceAt ?? null;
  const [imageErrors, setImageErrors] = useState(new Set());

  useEffect(() => {
    setImageErrors(new Set());
  }, [
    state.page,
    state.searchInput,
    state.startDate,
    state.endDate,
    state.sessionRegion,
    state.sessionCity,
    state.category1,
    state.category2,
    state.category3,
    state.category4,
    state.category5,
  ]);

  const handleImageError = (id) => {
    setImageErrors((prev) => new Set(prev).add(id));
  };

  const coursesToRender =
    state.learningActivities?.allFilteredCourses ||
    state.learningActivities?.courses ||
    state.learningActivities?.filteredCourses ||
    [];

  return (
    <Box sx={{ mt: 1 }}>
      {coursesToRender.length > 0
        ? coursesToRender.map((learningActivity) => (
            <CourseListItem
              key={`learningActivityList-${learningActivity.id}`}
              learningActivity={learningActivity}
              languageContext={languageContext}
              state={state}
              imageErrors={imageErrors}
              onImageError={handleImageError}
              isNextApplicationSort={isNextApplicationSort}
              nextApplicationSortReferenceAt={nextApplicationSortReferenceAt}
            />
          ))
        : null}
    </Box>
  );
};

export default CourseList;
